<template>
  <svg
    fill="none"
    height="96"
    viewBox="0 0 706 96"
    width="706"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M353 1.99994V1.99994C353 15.9719 353 22.9578 355.144 28.5165C358.395 36.9439 365.056 43.6049 373.483 46.8557C379.042 48.9999 386.028 48.9999 400 48.9999L658.499 48.9999C672.003 48.9999 678.755 48.9999 684.15 51.0052C692.873 54.2478 699.752 61.1271 702.995 69.85C705 75.2446 705 81.9966 705 95.5005V95.5005"
      stroke="#E2E9F6"
    />
    <path
      d="M353 1.99991V1.99991C353 15.9719 353 22.9579 350.856 28.5166C347.605 36.9439 340.944 43.6049 332.517 46.8557C326.958 48.9999 319.972 48.9999 306 48.9999L47.5 49C33.9967 49 27.245 49 21.8506 51.0051C13.1273 54.2477 6.24772 61.1272 3.00516 69.8505C0.999998 75.2449 0.999999 81.9966 1 95.5V95.5"
      stroke="#E2E9F6"
    />
    <path
      d="M353 0.000473022L353 93.5005"
      stroke="#E2E9F6"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpWhoIsForLinesDesktop',
}
</script>